import React from 'react';

import Header from './Header';
import SearchSection from './SearchSection';
import DescriptionSection from './DescriptionSection';
import FeaturesSection from './FeaturesSection';

const SearchPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-blue-50">
      <Header />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <DescriptionSection />
        <SearchSection />
        <FeaturesSection />
      </main>
    </div>
  );
};

export default SearchPage;
